<div class="card-container">
    <div class="container-row">
        <div class="col-8"></div>
        <div class="col-2 center">
            <p>Commencement Date</p>
        </div>
        <div class="col-2 center">
            <p>Status</p>
        </div>
    </div>
</div>
